// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл)
// Белый разделитель между секторами круговых диаграмм (пузыри-пироги теплокарты heatmap_pie, круги ячеек cellRing_conic в секторном режиме).
// Разделитель — белый «клин» conic-gradient на каждой границе секторов (включая границу 12 часов), угловая ширина g = 2·asin(w / d): у края круга
// хорда клина = w px, к центру клин сходится (как радиальная линия). Толщина w от диаметра d: d ≥ 24 px — 1.5 px, d ≥ 14 px — 1 px, меньше — без
// разделителя (на мелких кругах линия съела бы сектора). Один сектор (100 %) — без линии. Узкий сектор не исчезает: клин границы не шире половины
// меньшего из соседних секторов. Чистые функции (без Vue и DOM) — tests/unit/pieGaps.test.mjs.
// Выключатель fe.ux.pieSliceGaps (дефолт ВКЛ, §8): ВЫКЛ — сектора встык, как раньше.
export const PIE_GAPS_FLAG = 'fe.ux.pieSliceGaps'
export const PIE_GAP_COLOR = '#fff'

export function pieGaps_on(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(PIE_GAPS_FLAG, true) !== false : true } catch (e) { return true }
}

// толщина линии у края круга диаметра d (px): ≥ 24 — 1.5, ≥ 14 — 1, иначе 0
export function pieGap_width(d) {
    const n = Number(d)
    if (!Number.isFinite(n)) return 0
    return n >= 24 ? 1.5 : (n >= 14 ? 1 : 0)
}

// угловая ширина клина (градусы) для круга диаметра d: 2·asin(w / d); нет линии — 0
export function pieGap_deg(d) {
    const w = pieGap_width(d)
    if (!(w > 0)) return 0
    return 2 * Math.asin(Math.min(1, w / Number(d))) * 180 / Math.PI
}

// части [{ color, share }] (share > 0, соседние разных цветов) → стопы conic-gradient в градусах от 12 часов по часовой.
// gapDeg 0 / меньше двух частей — встык (как прежний heatmap_pie). Углы — с точностью 0.1°, последний сектор замыкается на 360deg.
// С зазором: границы b_0 = 0, b_1 … b_n = 360; клин границы k — [b_k − h_k, b_k + h_k], h_k = min(gapDeg / 2, ширина меньшего соседа / 4)
export function pieGap_stops(parts, gapDeg) {
    const P = (Array.isArray(parts) ? parts : []).filter(p => p && Number(p.share) > 0)
    if (P.length < 2) return []
    const tot = P.reduce((s, p) => s + Number(p.share), 0)
    const deg = (x) => Math.round(x * 10) / 10
    const b = [0]
    let acc = 0
    P.forEach((p, i) => { acc += Number(p.share); b.push(i === P.length - 1 ? 360 : acc / tot * 360) })
    const g = Number(gapDeg) > 0 ? Number(gapDeg) : 0
    if (!g) return P.map((p, i) => `${p.color} ${deg(b[i])}deg ${i === P.length - 1 ? 360 : deg(b[i + 1])}deg`)
    const n = P.length
    const w = P.map((p, i) => b[i + 1] - b[i])
    // граница k (0 … n−1) между частью k−1 (для k = 0 — последней) и частью k
    const h = P.map((p, k) => Math.min(g / 2, Math.min(w[k], w[(k - 1 + n) % n]) / 4))
    const out = []
    out.push(`${PIE_GAP_COLOR} 0deg ${deg(h[0])}deg`)
    P.forEach((p, i) => {
        const from = deg(b[i] + h[i])
        const hn = i === n - 1 ? h[0] : h[i + 1]
        const to = deg(b[i + 1] - hn)
        out.push(`${p.color} ${from}deg ${to}deg`)
        out.push(i === n - 1 ? `${PIE_GAP_COLOR} ${to}deg 360deg` : `${PIE_GAP_COLOR} ${to}deg ${deg(b[i + 1] + hn)}deg`)
    })
    return out
}
